export default __webpack_public_path__ + "static/cat-3c9ab2a38b89e9a0529da153b46fbfa58701738356a8e2fede5336d676acd3fb.png";